import { CLEAR_CURRENT_JOB, CLEAR_CURRENT_LOCATION, GET_JOBS_LIST, GET_JOBS_LIST_FETCH_DONE, GET_JOB_CATEGORIES, GET_JOB_CATEGORIES_FETCH_DONE, GET_RECENTLY_POSTED, GET_RECENTLY_POSTED_FETCH_DONE, GET_SKILLS, GET_SKILLS_FETCH_DONE, GET_TOP_CATEGORIES, GET_TOP_CATEGORIES_FETCH_DONE, GET_TOP_CITIES, GET_TOP_CITIES_FETCH_DONE, RESET_CATEGORY, RESET_USER_PROFILE, RESET_USER_SESSION, SET_CATEGORY, SET_CURRENT_JOB, SET_CURRENT_LOCATION, SET_USER_PROFILE, SET_USER_SESSION } from "../actions/actionTypes";
import { combineReducers } from 'redux';
import jobs from '../data/jobs.json';
import { FETCH_APP_STATUS_TYPES, FETCH_APP_STATUS_TYPES_FAILED, FETCH_APP_STATUS_TYPES_SUCCESS } from "../actions/initAppActionTypes";

const initialState = {
    jobsList: jobs.jobs,
    isRequestInprogress: false,
    topJobCategories: [],
    topJobCities: [],
    skills: [],
    recentJobs: [],
    jobCategories: []
};

export const jobsList = (state = initialState.jobsList, action) => {
    switch (action.type) {
        case GET_JOBS_LIST:
            return [];
        case GET_JOBS_LIST_FETCH_DONE:
            return [...action.payload];
        default:
            return state;
    }
};

export const isRequestInprogress = (state = initialState.isRequestInprogress, action) => {
    switch (action.type) {
        case GET_JOBS_LIST:
        case GET_RECENTLY_POSTED:
            return true;
        case GET_JOBS_LIST_FETCH_DONE:
        case GET_RECENTLY_POSTED_FETCH_DONE:
            return false;
        default:
            return state;
    }
};

export const topCategories = (state = initialState.topJobCategories, action) => {
    switch (action.type) {
        case GET_TOP_CATEGORIES:
            return [];
        case GET_TOP_CATEGORIES_FETCH_DONE:
            return [...action.payload];
        default:
            return state;
    }
};

export const jobCategories = (state = initialState.jobCategories, action) => {
    switch (action.type) {
        case GET_JOB_CATEGORIES:
            return [];
        case GET_JOB_CATEGORIES_FETCH_DONE:
            console.log(action.payload, "action.payload");
            return [...action.payload];
        default:
            return state;
    }
};

export const topLocations = (state = initialState.topJobCities, action) => {
    switch (action.type) {
        case GET_TOP_CITIES:
            return [];
        case GET_TOP_CITIES_FETCH_DONE:
            return [...action.payload];
        default:
            return state;
    }
};


export const skills = (state = initialState.skills, action) => {
    switch (action.type) {
        case GET_SKILLS:
            return [];
        case GET_SKILLS_FETCH_DONE:
            return [...action.payload];
        default:
            return state;
    }
};

export const recentJobs = (state = initialState.recentJobs, action) => {
    switch (action.type) {
        case GET_RECENTLY_POSTED:
            return [];
        case GET_RECENTLY_POSTED_FETCH_DONE:
            return [...action.payload];
        default:
            return state;
    }
};

export const selectedJobId = (state = null, action) => {
    switch (action.type) {
        case SET_CURRENT_JOB:
            return action.payload;
        case CLEAR_CURRENT_JOB:
            return null;
        default:
            return state;
    }
};

export const filters = (state = {}, action) => {
    switch (action.type) {
        case SET_CURRENT_LOCATION:
            return { ...state, location: action.payload };
        case SET_CATEGORY:
            return { ...state, category: action.payload };
        case CLEAR_CURRENT_LOCATION:
            delete state.location;
            return state;
        case RESET_CATEGORY:
            delete state.category;
            return state;
        default:
            return state;
    }
};

export const userSession = (state = {}, action) => {
    switch (action.type) {
        case SET_USER_SESSION:
            return { ...action.payload };
        case RESET_USER_SESSION:
            return {};
        default:
            return state;
    }
};

export const totalActiveJobs = (state = null, action) => {
    switch (action.type) {
        case 'SET_TOTAL_ACTIVE_JOBS':
            return action.payload;
        case RESET_USER_SESSION:
        case GET_RECENTLY_POSTED:
            return null;
        default:
            return state;
    }
};

export const appStatusTypes = (state = null, action) => {
    switch (action.type) {
        case FETCH_APP_STATUS_TYPES_SUCCESS:
            return action.payload;
        case FETCH_APP_STATUS_TYPES_FAILED:
        case FETCH_APP_STATUS_TYPES:
            return [];
        default:
            return state;
    }
};

export const userProfile = (state = {
    phone1: '',
    location: '',
    state: '',
    noticePeriod: '',
    experience: '',
    currentEmployer: '',
    designation: '',
    interestArea: '',
    github: '',
    primarySkills: [],
    secondarySkills: [],
}, action) => {
    switch (action.type) {
        case SET_USER_PROFILE:
            return { ...action.payload };
        case RESET_USER_SESSION:
        case RESET_USER_PROFILE:
        case SET_USER_SESSION:
            return {};
        default:
            return state;
    }
};

// Search state reducers
export const searchData = (state = null, action) => {
    switch (action.type) {
        case 'SET_SEARCH_DATA':
            // Also persist to session storage
            if (action.payload) {
                sessionStorage.setItem('searchData', JSON.stringify(action.payload));
            }
            return action.payload;
        case 'CLEAR_SEARCH_DATA':
            sessionStorage.removeItem('searchData');
            return null;
        default:
            return state;
    }
};

export const searchResults = (state = { jobs: [], count: 0, loading: false }, action) => {
    switch (action.type) {
        case 'SET_SEARCH_RESULTS':
            return {
                ...state,
                jobs: action.payload.jobs || [],
                count: action.payload.count || 0,
            };
        case 'SET_SEARCH_LOADING':
            return {
                ...state,
                loading: action.payload,
            };
        case 'CLEAR_SEARCH_DATA':
            return { jobs: [], count: 0, loading: false };
        default:
            return state;
    }
};

const root = combineReducers({
    jobsList,
    isDataLoading: isRequestInprogress,
    topCategories,
    topLocations,
    skills,
    recentJobs,
    selectedJobId,
    filters,
    userSession,
    userProfile,
    totalActiveJobs,
    jobCategories,
    appStatusTypes,
    searchData,
    searchResults,
});

export default root;